import { useEffect, useRef, useState } from 'react'
import { sendEmail, TEMPLATES, COMPANY } from '../lib/emailjs'

export default function Subscribe({ t, onSubscribe }) {
  const ref = useRef(null)
  const [email, setEmail] = useState('')
  const [sending, setSending] = useState(false)

  useEffect(() => {
    const el = ref.current
    if (!el) return
    const observer = new IntersectionObserver(
      ([entry]) => { if (entry.isIntersecting) el.classList.add('visible') },
      { threshold: 0.1 }
    )
    observer.observe(el)
    return () => observer.disconnect()
  }, [])

  async function handleSubmit(e) {
    e.preventDefault()
    if (!email) {
      alert(t.modal_email_required)
      return
    }

    setSending(true)
    try {
      await sendEmail(TEMPLATES.subscribe, {
        email,
        company_name:  COMPANY.name,
        company_email: COMPANY.email,
        company_url:   COMPANY.url,
      })
      setEmail('')
      onSubscribe()
    } catch (err) {
      console.error('Subscribe EmailJS error:', err)
      // Still show success to user — subscription noted even if email fails
      setEmail('')
      onSubscribe()
    } finally {
      setSending(false)
    }
  }

  return (
    <section className="subscribe-section" id="subscribe">
      <div ref={ref} className="subscribe-inner fade-in">
        <div className="section-tag">{t.sub_tag}</div>
        <h2>
          {t.sub_h2_1} <em>{t.sub_h2_em}</em>{t.sub_h2_2 ? ` ${t.sub_h2_2}` : ''}
        </h2>
        <p>{t.sub_desc}</p>
        <form className="sub-form" onSubmit={handleSubmit}>
          <input
            className="sub-input"
            type="email"
            placeholder={t.sub_ph}
            value={email}
            onChange={(e) => setEmail(e.target.value)}
            required
          />
          <button type="submit" className="sub-btn" disabled={sending}>
            {sending ? '⏳' : t.sub_btn}
          </button>
        </form>
        <div className="sub-note">{t.sub_note}</div>
      </div>
    </section>
  )
}
